import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { SITE_CONTENT } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY_SITE = {
  games: [],
  players: [],
  coaches: [],
  news: [],
  gallery: [],
  college: [],
  videos: [],
  records: [],
  content: SITE_CONTENT,
};

const Ctx = createContext({ site: EMPTY_SITE, loading: true, refresh: () => {} });

export const useSite = () => useContext(Ctx);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(EMPTY_SITE);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/public/content`);
      setSite({
        games: r.data.games || [],
        players: r.data.players || [],
        coaches: r.data.coaches || [],
        news: r.data.news || [],
        gallery: r.data.gallery || [],
        college: r.data.college || [],
        videos: r.data.videos || [],
        records: r.data.records || [],
        content: { ...SITE_CONTENT, ...(r.data.content || {}) },
      });
    } catch {
      // keep empty site on API failure
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <Ctx.Provider value={{ site, loading, refresh: load }}>{children}</Ctx.Provider>;
};
